import React from 'react'
import {
  Container,
  Eyebrow,
  SectionTitle,
  Lede,
  Card,
} from '../AumhumSite/sections'
import { ArrowRight, BadgeCheck, ShieldCheck, UserCheck } from '../AumhumSite/icons'
import StepDots from './StepDots'

// Step 2: confidentiality teaser. The user has chosen a pathway; before
// asking for their phone number we explain *why* we need it (privacy +
// matching). Pre-login is intentionally minimal — no concerns / history /
// reports asked here. That happens post-login on /care/status.
export default function ConfidentialityTeaser({ pathwayLabel, onContinue, onBack }) {
  return (
    <Container className="pps-shell">
      <StepDots step={2} of={3} />
      <Eyebrow>Almost there</Eyebrow>
      <SectionTitle as="h1">Help us match you with the best specialist</SectionTitle>
      <Lede>
        Health is personal. To recommend the right
        {pathwayLabel ? <> <strong>{pathwayLabel.toLowerCase()}</strong> </> : ' '}
        specialist for you, we&rsquo;ll ask for a few details about what&rsquo;s going on.
        Create a free account so everything you share stays private and is used only to find
        you the best care.
      </Lede>

      <Card className="pps-card-form" emphasised>
        <div>
          <div className="pps-pathway-label">Why we ask you to sign up</div>
          <ul className="pps-confidentiality-list">
            <li>
              <ShieldCheck />
              <span>
                Your details are encrypted and shared only with the care team and the
                specialist you eventually book with.
              </span>
            </li>
            <li>
              <UserCheck />
              <span>
                A coordinator can follow up with you on WhatsApp, call or chat — your
                choice, anytime.
              </span>
            </li>
            <li>
              <BadgeCheck />
              <span>
                You stay in control: add or remove information, upload reports, or pause
                the request whenever you like.
              </span>
            </li>
          </ul>
        </div>
      </Card>

      <div className="pps-cta-row">
        {onBack ? (
          <button type="button" className="pps-btn is-ghost" onClick={onBack}>
            Back
          </button>
        ) : null}
        <button type="button" className="pps-btn is-primary" onClick={onContinue}>
          Create account <ArrowRight />
        </button>
      </div>
    </Container>
  )
}
